import { ReactNode } from 'react'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'
import './custom-navbar.css'

export interface NavBarTab {
  key: string
  label: ReactNode
  dataTestid?: string
  disabled?: boolean
  disabledTooltip?: string
  highlight?: boolean
}

interface CustomNavBarProps {
  tabs: NavBarTab[]
  activeTab: string
  onTabChange: (key: string) => void
  className?: string
}

export const CustomNavBar = ({
  tabs,
  activeTab,
  onTabChange,
  className,
}: CustomNavBarProps): JSX.Element => {
  return (
    <div className={`custom-navbar-tabs ${className ?? ''}`}>
      {tabs.map((tab) => {
        const tabClasses = [
          'custom-navbar-tab',
          activeTab === tab.key ? 'active' : '',
          tab.disabled ? 'custom-navbar-tab--disabled' : '',
          tab.highlight ? 'custom-navbar-tab--highlight' : '',
        ]
          .filter(Boolean)
          .join(' ')
        const tabNode = (
          <div
            key={tab.key}
            className={tabClasses}
            onClick={() => {
              if (tab.disabled) return
              onTabChange(tab.key)
            }}
            data-testid={tab.dataTestid}
            aria-disabled={tab.disabled || undefined}
          >
            {typeof tab.label === 'string' ? <h6 className="m-0">{tab.label}</h6> : tab.label}
          </div>
        )
        if (tab.disabled && tab.disabledTooltip) {
          return (
            <CustomTooltip key={tab.key} title={tab.disabledTooltip} placement="bottom">
              {tabNode}
            </CustomTooltip>
          )
        }
        return tabNode
      })}
    </div>
  )
}
